import { render } from "./WelcomePopup.vue?vue&type=template&id=b95dd7dc&scoped=true"
import script from "./WelcomePopup.vue?vue&type=script&lang=js"
export * from "./WelcomePopup.vue?vue&type=script&lang=js"

import "./WelcomePopup.vue?vue&type=style&index=0&id=b95dd7dc&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b95dd7dc"]])

export default __exports__